module.exports = __webpack_public_path__ + "static/media/Portrait-Original-10039.852580e1.jpg";